export default function checkIsNumber(val) {
    let regex = new RegExp("^[0-9]+$");
    return regex.test(val);
}
